export default __webpack_public_path__ + "static/media/사회적인정.9056c2e4.png";